Namespace 'Customer.Filters.Ticket'

class Customer.Filters.Ticket.SubtypeFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/subtype_filter']
  className: 'checkboxes filter-field-container sub-type-filter checkboxes-types d-flex'
  attributes:
    'hide-if-empty': 'sub_type'

  events:
    'input .followers_count': 'limitFollowersCount'

  initialize: ({allTypes, availableTypes, query}) ->
    @allTypes = allTypes
    @availableTypes = availableTypes
    @query = query

  render: ->
    @$el.html @template
      allTypes: @allTypes
      availableTypes: @availableTypes
      query: @query
    @

  limitFollowersCount: (event) ->
    followersCounter = event.target
    followersCounter.value = followersCounter.value.slice(0, 9) if followersCounter.value.length > 9

  showError: =>
    @_followersCountEl().addClass('is-invalid')

  cleanError: =>
    @_followersCountEl().removeClass('is-invalid')

  _followersCountEl: ->
    @$('.followers_count')
